/* eslint-disable max-len */
// Here is where you can define configuration overrides based on the execution environment.
// Supply a key to the default export matching the NODE_ENV that you wish to target, and
// the base configuration will apply your overrides before exporting itself.
const s = x => JSON.stringify(x)

export default {
  // NOTE: In development, we use an explicit public path when the assets
  // are served webpack by to fix this issue:
  // http://stackoverflow.com/questions/34133808/
  // webpack-ots-parsing-error-loading-fonts/34133809#34133809

  development: config => ({
    compiler_public_path: `http://${config.server_host}:${config.server_port}/`,
    proxy: {
      enabled: false,
      options: {
        host: 'http://localhost:8000',
        match: /^\/api\/.*/,
      },
    },
  }),

  staging: config => ({
    bugsnag_api_key: '110725555757eced3289d251080f83dc',
    compiler_public_path: '/',
    compiler_fail_on_warning: false,
    compiler_hash_type: 'hash',
    compiler_devtool: 'source-map',
    compiler_stats: {
      chunks: true,
      chunkModules: true,
      colors: true,
    },
    globals: Object.assign({}, config.globals, {
      __DOMAIN__: s('albakaos.com'),
      __URL_API__: s('https://api.albakaos.com'),
    }),
  }),

  pre_production: config => ({
    bugsnag_api_key: '110725555757eced3289d251080f83dc',
    compiler_public_path: '/',
    compiler_fail_on_warning: false,
    compiler_hash_type: 'hash',
    compiler_devtool: 'source-map',
    compiler_stats: {
      chunks: true,
      chunkModules: true,
      colors: true,
    },
    globals: Object.assign({}, config.globals, {
      __DOMAIN__: s('albatesting.com'),
      __URL_API__: s('https://api.albacross.com'),
    }),
  }),

  production: config => ({
    bugsnag_api_key: '110725555757eced3289d251080f83dc',
    compiler_public_path: '/',
    compiler_fail_on_warning: false,
    compiler_hash_type: 'hash',
    compiler_devtool: 'source-map',
    compiler_stats: {
      chunks: true,
      chunkModules: true,
      colors: true,
    },
    globals: Object.assign({}, config.globals, {
      __DOMAIN__: s('albacross.com'),
      __URL_API__: s('https://api.albacross.com'),
    }),
  }),
}
/* eslint-enable */
